import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Container, Content, Text } from './error.styles';
import { WhiteIcon } from '../snackbarRender.styles';
import { ICON_WINNOW_LOGO } from '../../icon';
import messages from '../snackbar.messages';

export class Error extends PureComponent {
  static propTypes = {
    state: PropTypes.string.isRequired,
  };

  render() {
    return (
      <Container state={this.props.state}>
        <Content>
          <WhiteIcon name={ICON_WINNOW_LOGO} size={34} />
          <Text>
            <FormattedMessage {...messages.error} />
          </Text>
        </Content>
      </Container>
    );
  }
}
